import React from 'react';
import { Grid, Typography } from '@mui/material';
import { Icon } from '@elements';
import Close from '@images/close.svg';
import { HeaderBox, StyledIconButton, StyledIconButtonWrapper } from './modal-title.styled';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ModalTitle = function ModalTitle(_ref) {
  var children = _ref.children,
      handleClose = _ref.handleClose;
  var titleContent = typeof children === 'string' ? /*#__PURE__*/_jsx(Typography, {
    variant: "h5",
    component: "p",
    children: children
  }) : children;
  return /*#__PURE__*/_jsx(HeaderBox, {
    children: /*#__PURE__*/_jsxs(Grid, {
      container: true,
      spacing: 2,
      flexWrap: "nowrap",
      alignItems: "center",
      justifyContent: "space-between",
      children: [/*#__PURE__*/_jsx(Grid, {
        item: true,
        xs: 12,
        children: titleContent
      }), /*#__PURE__*/_jsx(Grid, {
        item: true,
        xs: "auto",
        children: /*#__PURE__*/_jsx(StyledIconButtonWrapper, {
          children: /*#__PURE__*/_jsx(StyledIconButton, {
            onClick: handleClose,
            size: "large",
            children: /*#__PURE__*/_jsx(Icon, {
              src: Close,
              width: 24,
              height: 24
            })
          })
        })
      })]
    })
  });
};

ModalTitle.displayName = 'ModalTitle';
export { ModalTitle };